// extracted by mini-css-extract-plugin
export default {"title":"create_title__4N6Lr","container":"create_container__CClJt","header":"create_header__8MLw3"};